<template>
  <div
    v-if="isDeleteWidgetModalVisible"
    class="fixed top-0 left-0 flex justify-center items-center w-full h-full bg-modal z-50"
  >
    <DeleteWidgetModal
      :title="title"
      :widget-id="widget_id"
      @close="isDeleteWidgetModalVisible = false"
      @delete="deleteWidget"
    />
  </div>

  <div
    :id="id"
    class="p-3 bg-white cursor-pointer hover:bg-primary-main/20"
    :class="roundedClasses"
    @click="$router.push(`/widget/edit/${id}`)"
  >
    <div class="flex items-center gap-2">
      <h3 class="text-neutral-125 text-base font-normal">
        {{ title }}
      </h3>

      <div class="relative">
        <TooltipIcon
          v-if="widget_description != null"
          @mouseover="descriptionVisibility = true"
          @mouseleave="descriptionVisibility = false"
        />

        <div
          v-if="descriptionVisibility"
          class="absolute w-72 p-4 rounded-lg bg-white break-words z-10 shadow-secondary"
        >
          <p class="tooltip-content">
            {{ widget_description }}
          </p>
        </div>
      </div>

      <div
        title="Delete Widget"
        class="ml-auto text-neutral-75 hover:text-primary-main"
        @click.stop="isDeleteWidgetModalVisible = true"
      >
        <TrashCanIcon />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import DeleteWidgetModal from "./modals/DeleteWidgetModal.vue";
import TooltipIcon from "./icons/TooltipIcon.vue";
import TrashCanIcon from "./icons/TrashCanIcon.vue";

export default defineComponent({
  name: "WidgetCard",
  components: { DeleteWidgetModal, TooltipIcon, TrashCanIcon },
  props: {
    id: { type: String, require: true },
    title: { type: String },
    widget_id: { type: String },
    widget_description: { type: String, default: "" },
    isFirst: { type: Boolean },
    isLast: { type: Boolean },
  },
  emits: ["deleted"],

  data() {
    return {
      descriptionVisibility: false,
      isDeleteWidgetModalVisible: false,
    };
  },

  computed: {
    roundedClasses() {
      if (this.isFirst) {
        return 'rounded-t-lg'
      }

      if (this.isLast) {
        return 'rounded-b-lg'
      }

      return ''
    }
  },

  methods: {
    async deleteWidget(id: string) {
      const token = sessionStorage.getItem("TOKEN");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      try {
        await axios.delete(
          `${process.env.VUE_APP_API}v3/widgets/${id}`,
          config
        );

        this.isDeleteWidgetModalVisible = false;

        this.$emit('deleted', id, this.title);
      } catch (error) {
        console.error("error deleting widget");
      }
    },
  },
});
</script>
